import React from "react";
import * as ReactDOMClient from "react-dom/client";
import { Calculator } from "./Components/Calculator";
import { CalculatorProvider } from "./Contexts/CalculatorContext";
const Component = () => (React.createElement(CalculatorProvider, null,
    React.createElement(Calculator, null)));
const pricingCalculator = document.getElementById("rct-pricing-calculator");
if (pricingCalculator !== null) {
    ReactDOMClient.createRoot(pricingCalculator).render(React.createElement(Component, null));
}
